import { Typography } from '../../../../core/components/molecules/Typography';

interface IEmptyState {
  text: string;
  subtext: string;
}

export function EmptyState({ text, subtext }: IEmptyState) {
  return (
    <div className='flex w-full flex-col items-center justify-center'>
      <Typography weight='bold'>{text}</Typography>
      <Typography>{subtext}</Typography>
    </div>
  );
}
